import React from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import { useHistory } from 'react-router-dom'
import SectionEmptyState from 'components/section-empty-state'
import { TonalButton } from 'components/empty-page-state'
import PersonOutlineOutlinedIcon from 'components/material-symbol/icons/PersonOutline'

const ExistingCoachProfileState = () => {
  const history = useHistory()

  return (
    <Container maxWidth="md">
      <Box py={8}>
        <SectionEmptyState
          Icon={PersonOutlineOutlinedIcon}
          title="Coach Profile"
          caption="You already have a PGA.com coach profile. Open Coach Profile to view or edit it."
          bordered={false}
          action={
            <TonalButton onClick={() => history.push('/pga-coach/profile')}>
              Go to Coach Profile
            </TonalButton>
          }
        />
      </Box>
    </Container>
  )
}

export default ExistingCoachProfileState
